import React, { useCallback } from "react";
import { create, useModal } from "@ebay/nice-modal-react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export const TechnicalDesignModal = create(({ viewWithTable, children }) => {
  const modal = useModal();

  const handleClose = useCallback(() => {
    modal.hide();
  }, [modal]);

  return (
    <Modal
      isOpen={modal.visible}
      centered={true}
      toggle={handleClose}
      onClosed={handleClose}
      scrollable={true}
      size="lg"
      style={
        (viewWithTable && {
          maxWidth: "100rem",
          width: "100%",
        }) ||
        {}
      }
    >
      <ModalHeader toggle={modal.hide} tag="div" className="pb-0" />
      <ModalBody className="d-flex row m-0">{children}</ModalBody>
    </Modal>
  );
});
